import styled from 'styled-components';

export const ProductHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 100%;
  flex: 1;
`;

export const ProductTitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;
